import { createIconComponent } from '../../factory/create-icon-component';
export const TrendingDownIcon = createIconComponent(
  'TrendingDownIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 17.9999V12M22 17.9999H16M22 17.9999L17.5 13.4999L15.0001 11L14.5 10.4999C14.4203 10.4203 14.3805 10.3805 14.3453 10.3484C13.5824 9.65502 12.4176 9.65502 11.6547 10.3484C11.6195 10.3805 11.5797 10.4203 11.5 10.4999L11 11C10.4547 11.5452 10.1821 11.8179 9.88799 11.9636C9.32844 12.2409 8.6715 12.2409 8.11195 11.9636C7.81785 11.8179 7.54522 11.5452 6.99995 11L2 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
